export default "assets/images/home-scroll-cd75a90b.gif";